import { useTranslation } from 'react-i18next'

const useModalResources = (resources, updateResources) => {
    const { t } = useTranslation()
      const selectElementOfType = type => resources.find(resource => resource.resource_type === type)?.resource_value || ''
      const saleScript = selectElementOfType('sale_script')
      const learningLink = selectElementOfType('learning_link')
      const emailTemplateLink = selectElementOfType('email_template_link')
      const objections = selectElementOfType('objections')
      const optInSmsText = selectElementOfType('opt_in_sms_text')
      const onOptInSmsTextChange = event => updateResources('opt_in_sms_text', event.target.value)
    return {t, saleScript, learningLink, emailTemplateLink, objections, optInSmsText, onOptInSmsTextChange}
}

export default useModalResources
